export default __webpack_public_path__ + "static/media/pic2.a08f149c.jpg";